module.exports = __webpack_public_path__ + "static/media/oceanfloor.1bed685c.glb";